jQuery(document).on('submit', '.newsletter-form', function (e) {
    e.preventDefault();

    const $form = jQuery(this);
    const email = $form.find('input[name="email"]').val();
    const $response = jQuery('.enkeleksamen-newsletter-block .submit-response');

    fetch('/wp-json/enkeleksamen/v1/newsletter', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
    })
    .then(r => r.json())
    .then(res => {
        $response
            .hide()
            .text(res.message)
            .fadeIn(500);

        if (res.success) {
            $form.trigger('reset');
        }
    });
});
